import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'

export const ProviderNotionCommon = {
  key: 'notion',
  authentication: ProviderAuthenticationCommon.Oauth2({
    key: 'notion',
    authUrl: 'https://api.notion.com/v1/oauth/authorize',
    tokenUrl: 'https://api.notion.com/v1/oauth/token',
    scopes: [],
    // extra: {
    //   owner: 'user',
    // },
  }),
}

export type ProviderNotionAccountType = null

export type ProviderNotionConnectionType = {
  access_token: string
  token_type: string
  bot_id: string
  workspace_name: string
  workspace_icon: string
  workspace_id: string
  owner: {
    type: 'user'
    user: {
      object: string
      id: string
      name: string
      avatar_url: string
      type: string
      person: { email: string }
    }
  }
  duplicated_template_id: null
  request_id: string
  claimed_at: number
}
